export default __webpack_public_path__ + "static/media/bg.89ab158f.png";